export var itemStyles = {
  margin: '0 8px 12px 0'
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/businessapp-patternlibrary/lib/components/Header/filters/item.js
// module id = 220
// module chunks = 0